import React from "react";
import { Paragraph, ParagraphProps } from "../Paragraph";
import { Links, LinksProps } from "../Links";
import { Flex } from "../Flex";

interface Props {
  paragraph: ParagraphProps;
  linkList: LinksProps;
}

export const ParagraphCard: React.FC<Props> = ({ paragraph, linkList }) => {
  return (
    <Flex flexDirection={["column", "row"]}>
      {paragraph && <Paragraph pr={4} width={["100%", "70%"]} mb={4} {...paragraph} />}
      {linkList && <Links width={["100%", "30%"]} {...linkList} />}
    </Flex>
  );
};
